import { Home } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/lib/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer data-testid="site-footer" className="border-t border-black/5 bg-[#F5F5F7]">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Home className="w-5 h-5 text-[#1D1D1F]" />
              <span className="font-semibold text-[#1D1D1F] text-lg tracking-tight" style={{ fontFamily: 'Outfit, sans-serif' }}>
                Oona Flats
              </span>
            </div>
            <p className="text-sm text-[#86868B] leading-relaxed max-w-xs">
              {t("footer_desc")}
            </p>
          </div>
          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-[#86868B] mb-4">
              {t("footer_nav")}
            </h4>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-[#1D1D1F] hover:text-[#86868B] transition-colors">{t("nav_home")}</Link>
              <Link to="/unterkuenfte" className="text-sm text-[#1D1D1F] hover:text-[#86868B] transition-colors">{t("nav_listings")}</Link>
              <Link to="/kontakt" className="text-sm text-[#1D1D1F] hover:text-[#86868B] transition-colors">{t("nav_contact")}</Link>
              <Link to="/empfehlungen" className="text-sm text-[#1D1D1F] hover:text-[#86868B] transition-colors">{t("nav_tips")}</Link>
            </div>
          </div>
          <div>
            <h4 className="text-xs font-semibold tracking-[0.15em] uppercase text-[#86868B] mb-4">
              {t("footer_contact")}
            </h4>
            <div className="flex flex-col gap-3 text-sm text-[#1D1D1F]">
              <span>Wien, Österreich</span>
              <a href="mailto:office@sharedspace-rentals.com" className="hover:text-[#86868B] transition-colors">
                office@sharedspace-rentals.com
              </a>
            </div>
          </div>
        </div>
        <div className="mt-12 pt-8 border-t border-black/5 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#86868B]">
          <span>&copy; {new Date().getFullYear()} Oona Flats. {t("footer_rights")}</span>
          <div className="flex items-center gap-4">
            <Link to="/impressum" className="hover:text-[#1D1D1F] transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-[#1D1D1F] transition-colors">Datenschutz</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
